import React from 'react';
import { clsx } from 'clsx';
import classes from './BranchName.module.css.js';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function BranchName(props, ref) {
  const {
    as: Component = 'a',
    className,
    children,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(BoxWithFallback, _extends({
    as: Component
  }, rest, {
    ref: ref,
    className: clsx(className, classes.BranchName)
  }), children);
}
BranchName.displayName = "BranchName"; // eslint-disable-next-line @typescript-eslint/ban-types
const fixedForwardRef = React.forwardRef;

// eslint-disable-next-line @typescript-eslint/no-explicit-any

BranchName.displayName = 'BranchName';
var BranchName$1 = fixedForwardRef(BranchName);

export { BranchName$1 as default };
